<div style="cursor: pointer">
  <mat-icon (click)="copyLinkToClipboard()" matTooltip="{{translate.instant('urlInvitation.title')}}"
            matTooltipPosition="above">
    link
  </mat-icon>
</div>
